import themeStore from '@/store/theme';
import { createGlobalStyle } from 'styled-components';

// overwrite global css here
export const GlobalStyle = createGlobalStyle`
  font-family: VFont;
  button {
    outline: 0;
    border: 0;
  }
  .ant-collapse-content-box {
    overflow: scroll;
  }
  .swal-modal {
    width: 80%;
    min-width: 300px;
    max-width: 420px;
    button {
      outline: 0 !important;
    }
    .swal-footer {
      text-align: center;
    }
    .swal-button-container {
      width: 100%;
      margin: 5px 0;
    }
    .swal-button {
      width: 100%;
      height: 44px;
      padding: 0;
      font-size: 16px;
      font-family: VFont, Arial;
      border-radius: 4px;
      background: ${themeStore.getPrimaryColor()};
      color: #fff;
      border: none;
      cursor: pointer;
      transition: 0.2s linear all;
      &:hover {
        background: ${themeStore.getData().primaryColor};
      }
      &:focus {
        box-shadow: none;
      }
    }
  }
  .sweet-alert-custom {
    h2 {
      display: none;
    }
  }
`;
